function projectsSmall(){
    if(jQuery('.projects-small')){
        var $grid = jQuery('.projects-small .projects-container').isotope({
            itemSelector: '.single-project',
            percentPosition: true,
            layoutMode: 'fitRows',
            fitRows: {
                gutter: '.gutter-sizer'
            }
        });

        $grid.imagesLoaded().progress( function() {
            $grid.isotope('layout');
            if(jQuery(window).width() > 640){
                var maxHeight = 0;
                jQuery('.single-project').css('height', 'auto');
                jQuery('.single-project').each(function(){
                    var thisH = jQuery(this).height();
                    if (thisH > maxHeight) { maxHeight = thisH; }
                });
                jQuery('.single-project').css('height', maxHeight+'px');
            }else{
                jQuery('.single-project').css('height', 'auto');
            }
        });

        jQuery('.project-filter').click(function() {
            jQuery('.project-filter').removeClass('active');
            jQuery(this).addClass('active');
            jQuery('.projects-container').addClass('is-animating');
            $grid.on( 'layoutComplete', function( event, laidOutItems ) {
                setTimeout(function(){
                    jQuery('.projects-container').removeClass('is-animating');
                }, 100);
            } );
            var filterValue = jQuery( this ).attr('data-filter');
            $grid.isotope({ filter: filterValue });
            $grid.isotope('shuffle');
        });

        jQuery('select.project-filter-select').on('change', function() {
            jQuery('.projects-container').addClass('is-animating');
            $grid.on( 'layoutComplete', function( event, laidOutItems ) {
                setTimeout(function(){
                    jQuery('.projects-container').removeClass('is-animating');
                }, 100);
            } );
            $grid.isotope({ filter: this.value });
            $grid.isotope('shuffle');
        });

        if(jQuery('.projects-small').is(':last-child')){
            jQuery('.projects-small').css('padding-bottom', '0px');
        }
    }
}
